export default "__VITE_ASSET__DzpT78Yf__"